import { render, staticRenderFns } from "./add-customer-seal.vue?vue&type=template&id=6f968ef4&scoped=true&"
import script from "./add-customer-seal.vue?vue&type=script&lang=js&"
export * from "./add-customer-seal.vue?vue&type=script&lang=js&"
import style0 from "./add-customer-seal.vue?vue&type=style&index=0&id=6f968ef4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f968ef4",
  null
  
)

export default component.exports